import { Moment } from 'moment-timezone/moment-timezone'

export interface CartItemType {
  type: TicketType
  name: string
  ticketPrice: number
  ticketCount: number
  totalPrice: number
  group: TicketGroup
}

export type CartItem = TimedItem | UntimedItem

export function isTimedItem(item): item is TimedItem {
  return Boolean(item.sessionId)
}

export interface TimedItem extends BaseItem {
  sessionId: string
  startMoment: Moment
  endMoment: Moment
  allDay: boolean
}

export interface UntimedItem extends BaseItem {
  validToMoment: Moment
  validFromMoment: Moment
  allDay: false
}

interface BaseItem {
  event: EventWithMeta

  /**
   * @deprecated Use event.id
   */
  templateId: string

  /**
   * @deprecated Use event.name
   */
  name: string

  /**
   * @deprecated Use event.meta
   */
  meta: MetaData

  /**
   * @deprecated Use event.meta?
   */
  imageUrl: string | undefined

  faceValue: number
  isAnchor: boolean
  isDependency: boolean
  isMembershipEvent: boolean
  ticketIds: string[]
  // TODO Include a middle level for ticket groups for session-cart items that include
  // ticket types from multiple different ticket groups? Maybe;
  //   1. `.types[].group` should be in a top level property of the cart item; `.groups`.
  //   2. Rename `.types` to something more general. Maybe "line items"?
  //   2. Remove `.types[].id`, or abstract it to a generic identifier.
  types: CartItemType[]
}
